'use client'

import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalTitle,
  ResponsiveModalTrigger,
} from '@/components/extension/responsive-modal'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { ArrowRight } from 'lucide-react'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { PreviewProductsModalContent } from '../collection-mix-match/collection-mix-match-item'

export type TMixMatchV2Look = {
  thumbnail: string
  productIds: string[]
  isVideo?: boolean
}

type Props = TMixMatchV2Look & {
  /** Prefix ga-tracking-value, không truyền thì không gắn tracking */
  trackingValue?: string
}

/**
 * Card look Mix & match (V2): ảnh bo 8px + link chữ "Mua set này" góc trái dưới.
 * Bấm vào card mở modal danh sách sản phẩm (dùng chung với V1).
 */
export const CollectionMixMatchV2Item: React.FC<Props> = ({
  thumbnail,
  productIds,
  isVideo,
  trackingValue,
}) => {
  const t = useTranslations('button')
  const label = t('buy_set')

  return (
    <ResponsiveModal>
      <ResponsiveModalTrigger asChild>
        <button
          type='button'
          aria-label={label}
          ga-tracking-value={
            trackingValue ? `${trackingValue}__buy-set` : undefined
          }
          ga-tracking-label={label}
          className='group relative block aspect-[434/581] w-full overflow-hidden rounded-lg bg-neutral-100 text-left'
        >
          {isVideo ? (
            <video
              className='absolute inset-0 size-full object-cover'
              loop
              playsInline
              muted
              autoPlay
            >
              <source src={thumbnail} type='video/mp4' />
            </video>
          ) : (
            <Image
              src={ImageHelper.getImageUrl(thumbnail, '', 870)}
              alt={label}
              fill
              sizes='(min-width: 1024px) 23vw, 260px'
              className='object-cover transition-transform duration-300 group-hover:scale-105'
            />
          )}

          <span className='absolute bottom-6 left-6 flex items-center gap-1 border-b border-neutral-50 py-1 font-criteria text-xs text-white lg:gap-2 lg:text-base lg:uppercase'>
            {label}
            <ArrowRight className='size-4 lg:size-6' strokeWidth={1.5} />
          </span>
        </button>
      </ResponsiveModalTrigger>
      <ResponsiveModalContent
        className='gap-0 border-none px-5 py-6 lg:h-[600px] lg:max-h-none lg:w-[1000px] lg:max-w-none lg:rounded-md lg:px-9 lg:py-10'
        aria-describedby={undefined}
      >
        <ResponsiveModalTitle className='hidden' />
        <ResponsiveModalDescription className='hidden' />
        <PreviewProductsModalContent
          productIds={productIds}
          thumbnail={thumbnail}
          isVideo={isVideo}
          trackingValue={trackingValue}
        />
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
